module.exports = __webpack_public_path__ + "static/media/ic_user.55633df5.svg";